import { SET_USER_APPS } from "./actionContants";

export const setUserApps = userAppsInfo => ({
	type: SET_USER_APPS,
	userAppsInfo
});
